<div class="d-flex flex-column page-header hub-builder">
  <div class="templateHeader d-flex">
      Hub - <span *ngIf="!workflow.name else nameOfWorkflow">Untitled*</span>
      <ng-template #nameOfWorkflow>{{workflow.name}}</ng-template>
      <div *ngIf="!isLoading">
        <button *ngIf="viewOnly && workflowStatus == 'Inactive'" (click)="inEditMode()" mat-list-item matTooltip="Edit" matTooltipPosition="right" class="btn actionBtn"><mat-icon class="action-icon-edit">edit</mat-icon></button>
        <button *ngIf="!viewOnly" (click)="save()" mat-list-item matTooltip="Save" matTooltipPosition="right" class="btn actionBtn add" [disabled]="!(workflow.component.length > 0)" [ngClass]="{ 'inactiveClss': !(workflow.component.length > 0)}"><mat-icon class="action-icon-save"></mat-icon></button>
      </div>
  </div>
</div>
<div *ngIf="isLoading" class="svg-loader"></div>
<div>
  <div class="modeler">
    <div id="canvas">
      <div class="io-zoom-controls">
        <ul class="io-zoom-reset io-control io-control-list">
          <li>
            <button title="reset zoom" (click)="canvasZoomReset()">
              <span class="icon-screenshot"></span>
            </button>
          </li>
          <li>
            <hr>
          </li>
          <li>
            <button title="zoom in" (click)="canvasZoomIn()">
              <span class="icon-plus"></span>
            </button>
          </li>
          <li>
            <hr>
          </li>
          <li>
            <button href="" title="zoom out" (click)="canvasZoomOut()">
              <span class="icon-minus"></span>
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div id="properties" *ngIf="!viewOnly"></div>
    <div id="customPalette" *ngIf="!viewOnly">
      <div class="pallet-nav">
        <div class="palletNav">
          <div *ngFor="let item of palletData" [ngClass]="{ 'activePallet': activPallet === item.componentType}" (click)="selectPalleteType(item.componentType)">{{item.componentType}}</div>
        </div>
      </div>
      <div class="palletContainer">
        <div class="search_box position-relative">
          <span class="searchIcon"></span>
          <input type="text" id="search" autocomplete="off" [ngModel]="searchText" (ngModelChange)="searchPallet($event)" placeholder="Search..." ngModel>
        </div>        
        <div *ngFor="let item of filteredPalletData">
          <div *ngIf="activPallet === item.componentType" class="palletScroll">
            <div *ngFor="let componentInfo of item.components" class="palletIcons"
                 (click)="selectComponent(componentInfo.componentName, componentInfo.componentType)"
                 ngbTooltip="{{componentInfo.componentName}}" placement="left">
              <div [ngClass]="'icon-custom'" *ngIf="componentInfo.componentName !== 'Scheduler'">
                <img alt="modelIconnnn" *ngIf="componentInfo.componentImage" [src]="'data:image/svg+xml;base64,' + componentInfo.componentImage | safe: 'url'" />
                <img alt="modelIconxxxx" *ngIf="!componentInfo.componentImage" src="assets/bpmn/defaultModel.svg" />
              </div>
              <div class="{{componentInfo.componentType}}" *ngIf="componentInfo.componentName !== 'Scheduler'">
                <span class="custom-workflowName">{{componentInfo.componentName}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="diagnosticsFrame">
    Diagnostics
  </div>
</div>
<ul class='custom-menu' *ngIf="showContextMenu" [style.left.px]="posX" [style.top.px]="posY">
  <li (click)="renameComponent()">Rename</li>
</ul>
